import React from 'react';
import '@/styles/weeklyReport.css';
import { formatEventDateRange } from '@/utils';

interface Event {
  id: string;
  title: string;
  dateTime: string;
  location?: string;
  htmlLink?: string;
}

interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  backgroundColor?: string;
  borderColor?: string;
  extendedProps?: {
    location?: string;
    description?: string;
    htmlLink?: string;
  };
}

interface SpaceEventsSectionProps {
  allEvents: Event[];
  calendarEvents: CalendarEvent[];
  calendarView: string;
  calendarDate: Date;
  isCalendarLoading: boolean;
  calendarRef: React.RefObject<any>;
  onEventCardClick: (eventId: string) => void;
  onCalendarViewChange: (view: string, setView: (view: string) => void) => void;
  onCalendarDateChange: (dateInfo: any) => void;
  onCalendarEventClick: (eventInfo: any) => void;
  setCalendarView: (view: string) => void;
}

const SpaceEventsSection: React.FC<SpaceEventsSectionProps> = ({
  allEvents,
  onEventCardClick,
}) => {
  return (
    <div className='bg-white rounded-2xl p-4 w-full max-w-[1400px] shadow-lg'>
      <div className='flex justify-between items-center pb-8 py-4 flex-wrap gap-4'>
        <div className='flex items-center gap-4'>
          <div className='w-12 h-12 rounded-xl flex items-center justify-center text-2xl bg-gradient-to-br from-blue-100 to-blue-200'>
            📅
          </div>
          <p className='text-lg font-bold text-slate-800'>Space Events</p>
        </div>
      </div>
      <div className='min-w-0 w-full bg-[#FAFAFA] border border-slate-200 rounded-lg overflow-hidden'>
        {allEvents.length > 0 ? (
          allEvents.map((event, index) => (
            <div
              key={event.id}
              className={`flex flex-col gap-3 px-4 pt-4 ${
                index === allEvents.length - 1 ? 'pb-4' : ''
              } transition-all cursor-pointer relative overflow-hidden h-fit hover:bg-white`}
              onClick={() => onEventCardClick(event.id)}
            >
              {index !== 0 && (
                <div className='w-full mx-auto border-b border-slate-200' />
              )}
              <div className='min-w-0 w-full'>
                <p className='text-sm font-semibold'>{event.title}</p>
              </div>
              <div className='text-xs text-slate-500 flex flex-col min-w-0'>
                <span>{formatEventDateRange(event.dateTime)}</span>
                <span className='truncate block'>
                  {event.location || 'N/A'}
                </span>
              </div>
              {event.htmlLink && event.htmlLink.match(/^https?:\/\//i) ? (
                <a
                  href={event.htmlLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='w-full self-start h-[32px] px-4 flex items-center justify-center bg-[#fccb16] text-center no-underline text-slate-800 border-none rounded-md text-sm cursor-pointer transition-all hover:bg-[#ffd84d] disabled:bg-slate-400 disabled:cursor-not-allowed'
                  onClick={(e: any) => e.stopPropagation()}
                >
                  Homepage
                </a>
              ) : null}
            </div>
          ))
        ) : (
          <p className='py-4 px-5'>No events match the current filter.</p>
        )}
      </div>
      {/* <CalendarView>
          <CalendarHeader>
            <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
              <EventCheckBox />
              <CalendarTabs>
                <CalendarTab
                  $active={calendarView === "dayGridMonth"}
                  onClick={() => onCalendarViewChange("dayGridMonth", setCalendarView)}
                >
                  Monthly
                </CalendarTab>
                <CalendarTab
                  $active={calendarView === "timeGridWeek"}
                  onClick={() => onCalendarViewChange("timeGridWeek", setCalendarView)}
                >
                  Weekly
                </CalendarTab>
              </CalendarTabs>
            </div>
          </CalendarHeader>
          {isCalendarLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
              <TableLoadingSpinner width={"3rem"} height={"3rem"} />
            </div>
          ) : (
            <CalendarContainer>
              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin]}
                dayMaxEventRows={7}
                initialView={calendarView}
                events={calendarEvents}
                datesSet={onCalendarDateChange}
                eventClick={onCalendarEventClick}
                headerToolbar={{
                  left: "prev",
                  center: "title",
                  right: "next",
                }}
                height="500px"
                eventDisplay="auto"
                eventTextColor="#001326"
                eventTimeFormat={{
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                }}
                fixedWeekCount={false}
                initialDate={calendarDate}
              />
            </CalendarContainer>
          )}
        </CalendarView> */}
    </div>
  );
};

export default SpaceEventsSection;
